import { Templates } from '@rjsf/mui';
import { BaseInputTemplateProps } from '@rjsf/utils';

const MuiBaseInputTemplate = Templates.BaseInputTemplate!;

// MUI v4 hides an empty field's placeholder behind the floating label until the field is focused;
// shrink the label whenever a placeholder is present so the placeholder is always visible.
export function ShrinkLabelBaseInputTemplate(props: BaseInputTemplateProps) {
  if (!props.placeholder) {
    return <MuiBaseInputTemplate {...props} />;
  }
  return (
    <MuiBaseInputTemplate
      {...props}
      slotProps={{ ...props.slotProps, inputLabel: { ...props.slotProps?.inputLabel, shrink: true } }}
    />
  );
}
